import React from 'react';
import Dashboard from 'components/Dashboard/Dashboard';
import 'styles/styles.css';

const App: React.FC = () => {
  return (
    <div className="app">
      <Dashboard />
    </div>
  );
};

export default App;